import { Stack } from "@mui/material";
import React, { useContext, useMemo } from "react";
import { context } from "utils/Provider";
import TableauEmbed from "../../../../components/TableauEmbed";
import { HEADROOM } from "common/constants";

interface Props {
  selectedProjectName: string;
}

export function Dashboard({ selectedProjectName }: Props): JSX.Element {
  const { token } = useContext(context);

  const vizFilters = useMemo(
    () => [
      {
        field: "Project Name",
        value: selectedProjectName,
      },
    ],
    [selectedProjectName]
  );

  return (
    <Stack sx={{ flex: 1, height: "100%", paddingTop: "1rem" }}>
      <TableauEmbed src={HEADROOM} token={token} device="default" vizFilters={vizFilters} />
    </Stack>
  );
}
